import * as React from "react";
import clsx from "clsx";
const Spinner = (props) => {
  const { className, text } = props;
  return /* @__PURE__ */ React.createElement("span", { className: clsx("spinner", className) }, /* @__PURE__ */ React.createElement("svg", { className: "spinner__circle", viewBox: "25 25 50 50", focusable: "false" }, /* @__PURE__ */ React.createElement("circle", { className: "spinner__path", cx: "50", cy: "50", r: "22", fill: "none" })), text && /* @__PURE__ */ React.createElement("span", { className: "spinner__text" }, text));
};
export {
  Spinner
};
